import type { TrendItemContentTweetsItemReferencedTweetTweetAuthorBasicInfo } from './trendItemContentTweetsItemReferencedTweetTweetAuthorBasicInfo';
import type { TrendItemContentTweetsItemReferencedTweetTweetAuthorSocial } from './trendItemContentTweetsItemReferencedTweetTweetAuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type TrendItemContentTweetsItemReferencedTweetTweetAuthor = {
  /** 사용자 기본 정보 */
  basicInfo: TrendItemContentTweetsItemReferencedTweetTweetAuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: TrendItemContentTweetsItemReferencedTweetTweetAuthorSocial;
};
